export enum RatingTypes {
	Outstanding = "Outstanding",
	Good = "Good",
	RequiresImprovement = "Requires Improvement",
	Inadequate = "Inadequate",
	NAIndependent = "NA - Independent",
	NAAcademy = "NA - Academy",
}
